const formatMoney = (value, option) => {
  const defaults = {
    style: 'currency',
    currency: 'EUR',
    currencySign: 'accounting',
    minimumFractionDigits: 2
  };
  const options = { ...defaults, ...option };
  return new Intl.NumberFormat('en-US', options).format(value);
};
const utils = {
  formatMoney
};
export default utils;
